import React, { useEffect, useState } from "react";
import { Header } from "../components/header";
import JsonData from "../data/data.json";
import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import Footer from "../components/footer";
import Slider from "react-slick";
import ACB from "../public/img/acb.png";
import Adani from "../public/img/adani.png";
import AILF from "../public/img/aifl.png";
import BandR from "../public/img/bandr.png";
import CSPTCL from "../public/img/csptcl.png";
import LT from "../public/img/lt.png";
import NTPC from "../public/img/ntpc.png";
import Lanco from "../public/img/lanco.png";
import KEC from "../public/img/kec.png";
import MissionVision from "../public/img/missionVision.jpg";
import Services from "../public/img/service.jpg";
import ErectionWork from "../public/img/ERECTION_LOGO.jpg";
import PipeLine from "../public/img/PIPELINE_JOB.jpg";
import MachineShop from "../public/img/Machine-shop.jpg";
import "./Home.css"
import { Navigation } from "../components/navigation";
import {Layout } from "../components/Layout"
import ClientSlide from "./clientSlide";

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true, // Add this line
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          infinite: true,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
     <>
    <Box sx={{margin:"0", padding:"0", bgcolor:"#d9d9d9"}} id="home">
      <Header data={landingPageData.Header} />
        {/* Erection Work */}

        <Box sx={{ py: 2,bgcolor:"#03203f" , padding: {xs: 4, sm: 4,  md: 4,}}}>
            <Box sx={{marginLeft:"1rem"}} >
              <Typography variant="h2" sx={{ fontWeight: "bold" }}>
                Erection <span style={{ color: "#009bd6" }}>Work</span>
              </Typography>
              <Divider  />
            </Box>
          <Grid container spacing={4}>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 5 }}>
                <div className="imagee-div">
                <img
                  className="imagee"
                  src={ErectionWork}
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
            <Grid item md={8} xs={12}>
              <Box sx={{padding: {xs: 1, sm: 2,  md: 3,} ,mt:{lg :2, md:2, sm:0} }}> {/**mt:{xs: 2, sm:2,  md:1,} */}
                <Typography
                    variant="h3"
                    sx={{
                      fontSize: "20px",
                      color: "#009bd6",
                      mt: 2,
                      mb: 1,
                      fontWeight: "bold",
                    }}
                  >
                    Equipment Erection & Structural Erection
                  </Typography>
                <Typography sx={{ fontSize: "16px" ,color:"#d9d9d9"}}>
                {data?.EquipmentErection}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* piplineJob */}
        <Box sx={{ py: 2, padding: {xs: 4, sm: 4,  md: 4,}}}>
          <Box sx={{marginLeft:"1rem"}} >
            <Typography variant="h2" sx={{ fontWeight: "bold" }}>
            <span style={{ color: "#03203f", textTransform:"uppercase" }}>pipeline</span> <span style={{ color: "#009bd6" }}>Work</span>
            </Typography>
              <Divider  />
          </Box>
          <Grid container spacing={4}>
          <Grid item md={8} xs={12}>
              <Box sx={{padding: {xs: 1, sm: 2,  md: 3,} }}> {/**mt:{xs: 2, sm:2,  md:1,} */}
                <Typography
                    variant="h3"
                    sx={{
                      fontSize: "20px",
                      color: "#009bd6",
                      mt: 2,
                      mb: 1,
                      fontWeight: "bold",
                    }}
                  >
                    Pipeline Job
                  </Typography>
                <Typography sx={{ fontSize: "16px" ,color:"#03203f"}}>
                {data?.Pipeline}
                </Typography>
              </Box>
            </Grid>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                <img
                  className="imagee"
                  src={PipeLine}
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* machine-shop */}
        <Box sx={{ py: 2,bgcolor:"#03203f" , padding: {xs: 4, sm: 4,  md: 4,}}}>
        <Box sx={{marginLeft:"1rem"}} >
        <Typography variant="h2" sx={{ fontWeight: "bold" }}>
              Machine <span style={{ color: "#009bd6" }}>Shop</span>
            </Typography>
              <Divider  />
            </Box>
          <Grid container spacing={4}>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 5 }}>
                <div className="imagee-div">
                <img
                  className="imagee"
                  src={MachineShop}
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
            <Grid item md={8} xs={12}>
              <Box sx={{padding: {xs: 1, sm: 2,  md: 3,},mt:{lg :2, md:2, sm:0} }}> {/**mt:{xs: 2, sm:2,  md:1,} */}
                <Typography
                    variant="h3"
                    sx={{
                      fontSize: "20px",
                      color: "#009bd6",
                      mt: 2,
                      mb: 1,
                      fontWeight: "bold",
                    }}
                  >
                    Pipeline Job
                  </Typography>
                <Typography sx={{ fontSize: "16px" ,color:"#d9d9d9"}}>
                {data?.MachineShop}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* mission vission */}
        <Box sx={{ py: 2, padding: {xs: 4, sm: 4,  md: 4,} }}>
          <Box sx={{marginLeft:"1rem"}} >
          <Typography variant="h2" sx={{ fontWeight: "bold" }}>
            <span style={{ color: "#03203f", textTransform:"uppercase" }}>Vision & </span><span style={{ color: "#009bd6" }}>Mission</span>
            </Typography>
            <Divider  />
          </Box>
          <Grid container spacing={4} >
            <Grid item md={8} xs={12}>
              <Box sx={{ padding: {xs: 1, sm: 2,  md: 3,},}}>
                <Typography
                    variant="h3"
                    sx={{
                      fontSize: "20px",
                      color: "#009bd6",
                      mt: 2,
                      mb: 1,
                      fontWeight: "bold",
                    }}
                  >
                  Vision
                </Typography>
                <Typography sx={{ fontSize: "16px", color:"#03203f" }}>
                {data?.vision}
                </Typography>
                <Typography
                    variant="h3"
                    sx={{
                      fontSize: "20px",
                      color: "#009bd6",
                      mt: 2,
                      mb: 1,
                      fontWeight: "bold",
                    }}
                  >
                  Mission
                </Typography>
                <Typography sx={{ fontSize: "15px", color:"#03203f" }}>
                {data?.mission}
                </Typography>
              </Box>
            </Grid>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                <img
                  className="imagee"
                  src={MissionVision}
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Services */}

        <Box sx={{ py: 2,bgcolor:"#03203f" , padding: {xs: 4, sm: 4,  md: 4,}}}>
          <Box sx={{marginLeft:"1rem"}} >
            <Typography variant="h2" sx={{ fontWeight: "bold" }}>
              Our <span style={{ color: "#009bd6" }}> Services</span>
            </Typography>
              <Divider  />
          </Box>
          <Grid container spacing={4}>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                <img
                  className="imagee"
                  src={Services}
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
            <Grid item md={8} xs={12}>
              <Box sx={{padding: {xs: 1, sm: 2,  md: 3,},mt:{lg :2, md:2, sm:0} }}> {/**mt:{xs: 2, sm:2,  md:1,} */}
                <Typography
                    variant="h3"
                    sx={{
                      fontSize: "20px",
                      color: "#009bd6",
                      mt: 2,
                      mb: 1,
                      fontWeight: "bold",
                    }}
                  >
                   Works
                  </Typography>
                <Typography sx={{ fontSize: "16px" ,color:"#d9d9d9"}}>
                  {data?.works}
                </Typography>

                {/* <Typography
                    variant="h3"
                    sx={{
                      fontSize: "20px",
                      color: "#009bd6",
                      mt: 2,
                      mb: 1,
                      fontWeight: "bold",
                    }}
                  >
                  Supply
                  </Typography>
                <Typography sx={{ fontSize: "16px" ,color:"#d9d9d9"}}>
                  {data?.supply}
                </Typography> */}
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* client */}
      <Box sx={{ height: 200 ,gap:2, bgcolor:"#d9d9d9", marginLeft:1, marginRight:1}} >
          <Box sx={{marginLeft:"1rem"}} >
            <Typography variant="h2" sx={{ fontWeight: "bold",color:"#03203f" }}>
              Our <span style={{ color: "#009bd6" }}> Clients</span>
            </Typography>
              <Divider  />
          </Box>
          <ClientSlide client={client}/>
        </Box>

      <Footer />
    </Box>
    </>
    
  );
};

export default Home;

const data = {
  vision:
    "Our mission is to deliver value to our shareholders and customers by providing engineering services, supplies, construction, the operation and management of infrastructure, industrial and energy projects.",
  mission:
    "To be the leading engineering and construction company, renowned for our working methodologies, technological heritage, and human resource capabilities.",
  works:
    "We do all kind of mechanical works like Fabrication, Erection, & Commissioning in Power, Steel & Coal industries.",
  supply:
    "We are leading manufacutrer of all kind of industrial equipments & Spares.",

  EquipmentErection:
    "Our company specializes in comprehensive erection work, including both equipment erection and structural erection. We ensure the precise assembly and installation of various machinery and industrial equipment, adhering to stringent safety and quality standards. Our experienced team manages the entire process from planning and logistics to on-site execution, guaranteeing minimal disruption to your operations. Structural erection involves constructing the framework of buildings and other structures, using advanced techniques and equipment to ensure stability and durability. With a focus on efficiency and precision, we deliver reliable and robust erection services tailored to meet the specific needs of each project.",
  Pipeline:
    "We offer specialized services in pipeline construction, maintenance, and repair, catering to industries such as oil and gas, water supply, and industrial manufacturing. Our pipeline job services include the installation of new pipelines, upgrades to existing systems, and emergency repairs to ensure uninterrupted flow. Utilizing state-of-the-art technology and adhering to industry best practices, we ensure that every pipeline project is executed with the highest level of safety, efficiency, and environmental responsibility. Our team of skilled professionals is dedicated to delivering projects on time and within budget, providing seamless and reliable pipeline solutions.",
  MachineShop:
    "Our machine shop is equipped with a single production line designed to handle a variety of machining tasks with precision and efficiency. We offer custom machining services, including milling, turning, drilling, and grinding, to meet the specific needs of our clients. Our skilled machinists work with a range of materials to produce high-quality components for various industries. With a focus on precision and quality, our machine shop ensures that each project is completed to the highest standards, delivering reliable and durable products that meet the exact specifications of our customers.",
};

const client = [
  { id: 1, img: ACB },
  { id: 2, img: Adani },
  { id: 3, img: AILF },
  { id: 4, img: BandR },
  { id: 5, img: CSPTCL },
  { id: 6, img: LT },
  { id: 7, img: NTPC },
  { id: 8, img: Lanco },
  { id: 9, img: KEC },
];